export default __webpack_public_path__ + "static/media/logrocket.6f1ec1ad.png";